import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "scheduleType",
    "weeklyFields",
    "monthlyFields",
    "customFields",
    "repeatUnit",
    "customWeekdays",
    "customMonthly",
    "endType",
    "endDate",
    "endCount"
  ]

  connect() {
    this.refresh()
  }

  refresh() {
    const scheduleType = this.scheduleTypeTarget.value
    const custom = scheduleType === "custom"
    const repeatUnit = this.repeatUnitTarget.value

    this.toggle(this.weeklyFieldsTarget, scheduleType === "weekly")
    this.toggle(this.monthlyFieldsTarget, scheduleType === "monthly")
    this.toggle(this.customFieldsTarget, custom)
    this.toggle(this.customWeekdaysTarget, custom && repeatUnit === "weeks")
    this.toggle(this.customMonthlyTarget, custom && repeatUnit === "months")
    this.toggle(this.endDateTarget, custom && this.endTypeTarget.value === "on_date")
    this.toggle(this.endCountTarget, custom && this.endTypeTarget.value === "after_count")
  }

  toggle(element, visible) {
    element.hidden = !visible
    element.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = !visible
    })
  }
}
